<template>
  <notification-list
    :is-loading="isLoading"
    :notifications="notifications"
    :pagination="pagination"
    :key="isVisible"
    @pagination="onPagination"
  />
</template>

<script>
import { API } from '@/utils/api'
import { NotificationList } from '../components'

export default {
  components: {
    NotificationList
  },
  props: {
    account: {
      type: Object,
      required: true
    },
    isVisible: Boolean
  },
  data() {
    return {
      notifications: [],
      pagination: {},
      isLoading: false,
    }
  },
  methods: {
    initialize() {
      this.isLoading = true
      this.loadNotifications().finally(() => this.isLoading = false)
    },
    loadNotifications(args = {}) {
      const { page = 1, perpage = 10 } = args
      return API.call('/$v/notification-center/notifications/list.json', {
        event: {
          account_id: this.account.account_id,
          page,
          perpage,
          order: [ { field: 'notification_id', direction: 'desc' } ]
        },
        login: this.account.login,
      }).then(r => (this.notifications = r.data, this.pagination = r.pagination))
    },

    onPagination({ itemsPerPage, page }) {
      if (itemsPerPage === -1) {
        itemsPerPage = this.pagination.total
      }

      this.isLoading = true
      this.loadNotifications({ page, perpage: itemsPerPage === -1 ? this.pagination.total : itemsPerPage }).finally(() => this.isLoading = false)
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.initialize()
      }
    }
  }
}
</script>
